<template>
  <div>
    <router-view/>
    <router-view :name="currentGroup.slug"></router-view>
  </div>
</template>

<script>
import Trial from '@/orm/models/Trial';
import Booking from '@/orm/models/Booking';

export default {
  name: 'Dashboard',
  async asyncData() {
    await Trial.$fetch();
    await Booking.$fetch();
  },
};
</script>
